export default "__VITE_ASSET__7f5090ed__"